<app-header></app-header>
<div id="auth" class="container-fluid">
  <div id="box_auth">
    <form action="" method="post">
      <div class="title_auth margin-0">{{'ChangePassword' | translate}}</div>
      <div class="excerpt_auth">{{'SetPasswordForYourAccount' | translate}}</div>
      <div class="box_auth_row">
        <input type="password" id="password" name="password" placeholder="{{'Password' | translate}}" [(ngModel)]="password.password">
      </div><!-- .login_row -->
      <div class="box_auth_row">
        <input type="password" id="re_password" name="password_confirmation" placeholder="{{'RePassword' | translate}}" [(ngModel)]="password.password_confirmation" (keyup.enter)="setPassword()">
      </div><!-- .login_row -->
      <div class="box_auth_row">
        <div>
          <button type="submit" (click)="setPassword()">
            {{'ChangePassword' | translate}}
            <mat-spinner style="margin: 0 5px 0 0; vertical-align: middle; display: inline-block !important;" matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="registerSpinner"></mat-spinner>
          </button>
        </div>
      </div><!-- .login_row -->
    </form>
  </div><!-- .box_auth -->
</div><!-- #auth -->
<app-footer></app-footer>
